
import Checkbox from "./Checkbox.js";
import StandardSubSettings from "./StandardSubSettings.js";
import { InputNumber, Row, Space } from "antd";

const SMHIWarningSettings = ({ settings, saveSettings }) => {
  var localSettings = StandardSubSettings(settings, "SMHIWarning");

  let risk = localSettings.risk;
  let brandrisk = localSettings.brandrisk;
  let highTemp = localSettings.highTemp;
  let location = localSettings.location;

  return (
    <div>
      <Checkbox
        name="Risk 1"
        text="Risk för mycket besvärligt väder"
        def={risk}
        onChange={() => {
          risk = !risk;
          localSettings.risk = risk;
          saveSettings(localSettings);
        }}
      />
      <Checkbox
        name="Risk 2"
        text="Brandrisk"
        def={brandrisk}
        onChange={() => {
          brandrisk = !brandrisk;
          localSettings.brandrisk = brandrisk;
          saveSettings(localSettings);
        }}
      />
      <Checkbox
        name="Risk 3"
        text="Medellande om mycket höga temperaturer"
        def={highTemp}
        onChange={() => {
          highTemp = !highTemp;
          localSettings.highTemp = highTemp;
          saveSettings(localSettings);
        }}
      />
      <Checkbox
        name="Risk 4"
        text="Använda din nuvarande plats"
        def={location}
        onChange={() => {
          location = !location;
          localSettings.location = location;
          saveSettings(localSettings);
        }}
      />

      <Row style={{ padding: "10px" }}>
        <Space>
          <p style={{ margin: "10px 0px 0px 0px" }}>
            Avisera om ny data finns inom:
          </p>
          <InputNumber
            min={0}
            defaultValue={localSettings.newDataHour}
            onChange={(value) => {
              localSettings.newDataHour = value;
              saveSettings(localSettings);
            }}
            step={0.5}
          />
          <p style={{ margin: "10px 0px 0px 0px" }}>timmar</p>
        </Space>
      </Row>
    </div>
  );
};
export default SMHIWarningSettings;
